import { createSlice } from "@reduxjs/toolkit";

const initialState = { accessToken: null, initialized: false };

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    clearAccessToken: (state) => {
      state.accessToken = null;
    },
    setInitialized: (state) => {
      state.initialized = true;
    },
  },
});

export const { setAccessToken, clearAccessToken, setInitialized } =
  authSlice.actions;
export const selectAccessToken = (state) => state.auth.accessToken;
export const selectInitialized = (state) => state.auth.initialized;
export default authSlice.reducer;
